/**
 * Calculator4 JS controller. (Osittaisen vanhuuseläkkeen laskuri)
 *
 * This class handles processing of second calculator form.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Calculator4. This gets mapped with the keyword Calculator4 and its
 * docready method is fired automatically on pages where there's a
 * class called 'Calculator4' on the html tag.
 */
class Calculator4 {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        // Instance of the Calculators utility class.
        this.utils = Theme.getController( 'Calculators' );

        // Store a shorthand reference to translatable strings.
        this.strings = themeData.themeStrings.calculators;

        // Calculator form.
        this.$form = this.utils.initForm( 'osittaisen-vanhuuselakkeen-laskuri' );

    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {

        // Bind a handler to form submit.
        this.$form.on( 'submit', e => this.calculateForm( e ) );

        // Prevent native HTML validation
        this.$form[0].noValidate = true;

        // Auto-submit the form? See Calculators class for details.
        if ( this.$form.data( 'submit' ) ) {
            this.$form.trigger( 'submit' );
        }

    }

    /**
     * Processing function for the form.
     *
     * @param {object} e Event object.
     */
    calculateForm( e ) {

        // Stop propagation
        Theme.Common.stop( e );

        // Placeholder for calculated data.
        this.calculatedData = {
            'charts': {
            }
        };

        // Validate and store form values in class property validatedData.
        this.validatedData = this.utils.validateForm( this.$form, {
            'birth_year': 0,                 // int >=0
            'birth_month': 0,                // int 1-12
            'accumulated_pension': 0,        // float >=0 (EUR/month)
            'work_income': 0,                // int >=0 (EUR/year)
            'wage_income': 0,                // int >=0 (EUR/year)
            'partial_pension_age_years': 0,  // int >=61
            'partial_pension_age_months': 0, // int 0-11
            'pension_age_years': 0,          // int >=61
            'pension_age_months': 0,         // int 0-11
            'ongoing_work_income': 0,        // int >=0 (EUR/year)
            'ongoing_wage_income': 0         // int >=0 (EUR/year)
        });

        // Calculate pension.
        this.calculatedData.charts = this.utils.calculatePartialPension(
            this.validatedData.work_income,
            this.validatedData.wage_income,
            this.validatedData.accumulated_pension,
            this.validatedData.birth_year,
            this.validatedData.birth_month,
            this.validatedData.partial_pension_age_years * 12 + this.validatedData.partial_pension_age_months,
            this.validatedData.pension_age_years * 12 + this.validatedData.pension_age_months,
            this.validatedData.ongoing_work_income,
            this.validatedData.ongoing_wage_income
        );

        // Render output.
        this.outputForm();

    }

    /**
     * Render output for the first form.
     */
    outputForm() {

        // Stop here if errors were found.
        if ( this.utils.validator.errorLog.length ) {
            this.utils.outputErrors( this.$form );
            return false;
        }

        // Create container for output.
        const $container = this.utils.renderResultsContainer( this.$form );

        // Add calculation parameters.
        const $params = this.utils.renderParams(
            this.$form,
            this.validatedData,
            {
                'accumulated_pension': {
                    'ext': 'eur_per_month'
                },
                'work_income': {
                    'ext': 'eur_per_year'
                },
                'wage_income': {
                    'ext': 'eur_per_month'
                },
                'ongoing_work_income': {
                    'ext': 'eur_per_year'
                },
                'ongoing_wage_income': {
                    'ext': 'eur_per_month'
                },
                'partial_pension_age_years': {
                    'ext': 'yr',
                    'label': 'partial_pension_age'
                },
                'partial_pension_age_months': {
                    'appendTo': 'partial_pension_age_years',
                    'skip': this.validatedData.partial_pension_age_months == 0,
                    'ext': 'mo'
                },
                'pension_age_years': {
                    'ext': 'yr',
                    'label': 'pension_age'
                },
                'pension_age_months': {
                    'appendTo': 'pension_age_years',
                    'skip': this.validatedData.pension_age_months == 0,
                    'ext': 'mo'
                }
            }
        );
        $params.appendTo( $container );

        // Chart options.
        const chartOptions = {
            scales: {
                xAxes: [ {
                    barPercentage: 1.0,
                    categoryPercentage: 1.0
                } ]
            }
        };

        // Add chart #1 to container.
        const $chart1 = this.utils.renderChart(
            this.calculatedData.charts.data[25],
            this.strings.partial_pension.replace( '%d', 25 ),
            chartOptions
        );
        $chart1
            .addClass( 'calculator-container__chart--half' )
            .appendTo( $container );

        // Add chart #2 to container.
        const $chart2 = this.utils.renderChart(
            this.calculatedData.charts.data[50],
            this.strings.partial_pension.replace( '%d', 50 ),
            chartOptions
        );
        $chart2
            .addClass( 'calculator-container__chart--half' )
            .appendTo( $container );

        if ( this.calculatedData.charts.heading ) {

            // Add heading before first chart.
            const $heading = this.utils.renderHeading( this.calculatedData.charts.heading );
            $heading.insertBefore( $chart1 );

        }

        if ( this.calculatedData.charts.info ) {

            // Add info text to container.
            const $info = this.utils.renderInfo([
                this.calculatedData.charts.info
            ]);
            $info.appendTo( $container );

        }

        // Append action buttons.
        const $buttons = this.utils.renderButtons( this.$form );
        $buttons.appendTo( $container );

        // Add extra content.
        this.utils.renderExtra( this.$form, $container );

    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        if ( this.$form && this.$form.length ) {
            this.events();
        }
    }

}

// Export the class reference.
module.exports = Calculator4;



// WEBPACK FOOTER //
// ./assets/scripts/calculator4.js